import moment from "moment";
import * as XLSX from "xlsx";
import { Download } from "lucide-react";

export default function ReportCard({ selectedMonth, mainarray }) {
  const exportToExcel = () => {
    const dataToExport = mainarray.map((item) => ({
      "Ad Soyad": `${item.user?.name || ""} ${item.user?.surname || ""}`.trim(),
      TCKN: item?.user?.tc || "",
      "Hastalık izni": item?.Sick || "0",
      "Yıllık izin": item?.Annual || "0",
      "Doğum izni": item?.Birth || "0",
      "Ücretsiz izin": item?.Paid || "0",
      "Çalışılan Gün": item?.finalWorkingDays || "0",
      "İzinli Gün": item?.IzinGun
        ? item.IzinGun.map((day) => `${day.date}${day.isHalfDay ? " (Yarım Gün)" : ""}`).join(", ")
        : "Bulunamadı.",
      "Çalışma Saati": item?.finalWorkingHours || "",
    }));
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    ws["!cols"] = [
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
      { wch: 12 },
      { wch: 8 },
      { wch: 12 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rapor");
    XLSX.writeFile(wb, `rapor_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-4 pb-2 border-b">
        <h3 className="font-bold text-lg text-gray-800">
          Seçilen Ay: <span className="text-blue-600">{moment(selectedMonth).format("MMMM YYYY")}</span>
        </h3>
        <button
          onClick={exportToExcel}
          className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded-lg transition-colors text-sm shadow-sm"
        >
          <Download size={16} />
          Excel'e Aktar
        </button>
      </div>

      <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
        <table className="w-full text-left text-sm border-collapse min-w-[850px]">
          <thead>
            <tr className="bg-gray-100 text-gray-700 font-semibold border-b text-xs uppercase tracking-wider">
              <th className="py-3 px-4">Kullanıcı</th>
              <th className="py-3 px-3 text-center">Hastalık İzni</th>
              <th className="py-3 px-3 text-center">Yıllık İzin</th>
              <th className="py-3 px-3 text-center">Doğum İzni</th>
              <th className="py-3 px-3 text-center">Ücretsiz İzin</th>
              <th className="py-3 px-3 text-center">Çalışılan Gün</th>
              <th className="py-3 px-4">İzin Kullanılan Günler</th>
              <th className="py-3 px-3 text-center">Çalışma Saati</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {mainarray.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50/80 transition-colors">
                <td className="py-3 px-4 font-medium text-gray-900 whitespace-nowrap">
                  {item.user?.name} {item.user?.surname}
                  <div className="text-xs text-gray-400 font-mono">{item.user?.tc}</div>
                </td>
                <td className="py-3 px-3 text-center font-semibold text-gray-700">{item.Sick}</td>
                <td className="py-3 px-3 text-center font-semibold text-gray-700">{item.Annual}</td>
                <td className="py-3 px-3 text-center font-semibold text-gray-700">{item.Birth}</td>
                <td className="py-3 px-3 text-center font-semibold text-gray-700">{item.Paid}</td>
                <td className="py-3 px-3 text-center font-bold text-blue-600">{item.finalWorkingDays}</td>
                <td className="py-3 px-4">
                  {item.finalLeaveDays > 0 ? (
                    <ul className="list-disc list-inside text-gray-600 text-xs space-y-0.5">
                      {item.IzinGun.map((dayObj, i) => (
                        <li key={i}>
                          {dayObj.date} {dayObj.isHalfDay ? "(Yarım Gün)" : ""}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-gray-400 text-xs italic">İzin kullanılmadı</span>
                  )}
                </td>
                <td className="py-3 px-3 text-center font-semibold text-gray-700">{item.finalWorkingHours}s</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
